import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "p-6" }
const _hoisted_2 = { class: "max-w-5xl mx-auto mb-4 flex justify-end" }
const _hoisted_3 = { class: "relative" }
const _hoisted_4 = { class: "relative inline-flex items-center gap-1 rounded-lg border border-white/30 bg-gray-100/80 backdrop-blur-sm shadow-sm hover:shadow-md transition-all duration-300 px-1 py-1 overflow-hidden" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { class: "mr-2" }
const _hoisted_7 = {
  key: 0,
  class: "pointer-events-none absolute inset-0 rounded-md",
  style: {"background":"linear-gradient(\n                  120deg,\n                  rgba(255, 255, 255, 0.25) 0%,\n                  rgba(255, 255, 255, 1) 100%\n                )","opacity":"1","z-index":"-1"}
}
const _hoisted_8 = { class: "max-w-5xl mx-auto bg-white rounded-2xl shadow-lg p-8 grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_9 = { class: "md:col-span-1 border-r pr-6" }
const _hoisted_10 = { class: "md:col-span-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProfileHeader = _resolveComponent("ProfileHeader")!
  const _component_SkillsList = _resolveComponent("SkillsList")!
  const _component_Languages = _resolveComponent("Languages")!
  const _component_WorkExperience = _resolveComponent("WorkExperience")!
  const _component_Education = _resolveComponent("Education")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.locales, (l) => {
            return (_openBlock(), _createElementBlock("div", {
              key: l.code,
              onClick: ($event: any) => (_ctx.setLanguage(l.code)),
              class: _normalizeClass([
              'flex items-center px-4 py-1.5 rounded-md text-sm font-medium transition-all duration-300 relative cursor-pointer select-none',
              _ctx.isActive(l.code)
                ? 'text-gray-900 shadow-sm'
                : 'text-gray-700 hover:text-gray-900',
            ])
            }, [
              _createElementVNode("span", _hoisted_6, _toDisplayString(l.flag), 1),
              _createTextVNode(" " + _toDisplayString(l.label) + " ", 1),
              (_ctx.isActive(l.code))
                ? (_openBlock(), _createElementBlock("span", _hoisted_7))
                : _createCommentVNode("", true)
            ], 10, _hoisted_5))
          }), 128))
        ]),
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "absolute inset-0 rounded-lg bg-gradient-to-br from-white/15 to-transparent pointer-events-none" }, null, -1))
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createVNode(_component_ProfileHeader),
        _createVNode(_component_SkillsList, { highlightedSkillIds: _ctx.highlightedSkillIds }, null, 8, ["highlightedSkillIds"]),
        _createVNode(_component_Languages)
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_WorkExperience, {
          onActiveSkillIds: _cache[0] || (_cache[0] = ($event: any) => (_ctx.highlightedSkillIds = $event))
        }),
        _createVNode(_component_Education)
      ])
    ])
  ]))
}